/**
 * Space SKU view stays mounted across item-id changes (same route component).
 * Do not render the edit form until the loaded item matches the route,
 * otherwise react-hook-form state from the previous SKU can be submitted
 * onto the newly selected SKU.
 */
export function isSpaceSkuViewDataReady<TItem extends { id: string }>(
  item: TItem | null | undefined,
  itemId: string | undefined
): item is TItem {
  return Boolean(item && itemId && String(item.id) === String(itemId));
}
